const Index = {
    aboutInputs: process.env.REACT_APP_MAIL_ABOUT_INPUTS,
    contact: process.env.REACT_APP_MAIL_CONTACT,
    inputs: process.env.REACT_APP_MAIL_INPUTS,
};

export default Index;
